import { UTM_FIELDS, type UtmField } from '@ecom/contracts';

/**
 * A store link tagged for a campaign (ADR-097): the `utm_*` tags set or
 * cleared, everything else in the link left as it was.
 */
export function campaignUrl(link: string, tags: Partial<Record<UtmField, string>>): string {
  const url = new URL(link);
  for (const field of UTM_FIELDS) {
    const value = tags[field]?.trim();
    if (value) url.searchParams.set(`utm_${field}`, value);
    else url.searchParams.delete(`utm_${field}`);
  }
  return url.toString();
}
